import { createStyles } from "@mantine/emotion";

const EASE_OUT = "cubic-bezier(0.22, 1, 0.36, 1)";
const REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";

const useStyles = createStyles(theme => ({
  animation: {
    position: "absolute",
    right: 26,
    bottom: -15,
    width: 288,
    opacity: 0.5,
    pointerEvents: "none",
  },
  arch: {
    width: "100%",
    height: "auto",
    overflow: "visible",
  },
  archLine: {
    fill: "none",
    stroke: theme.colors.brand[4],
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeDasharray: 640,
    strokeDashoffset: 640,
    animation: `loginArchDraw 9s ${EASE_OUT} infinite`,
    "@keyframes loginArchDraw": {
      "0%": { strokeDashoffset: 640 },
      "28%": { strokeDashoffset: 0 },
      "82%": { strokeDashoffset: 0, opacity: 1 },
      "100%": { strokeDashoffset: 0, opacity: 0 },
    },
    [REDUCED_MOTION]: { animation: "none", strokeDashoffset: 0 },
  },
  tooth: {
    fill: theme.colors.brand[3],
    opacity: 0,
    transformBox: "fill-box",
    transformOrigin: "center",
    animation: `loginToothPop 9s ${EASE_OUT} infinite`,
    "@keyframes loginToothPop": {
      "0%, 18%": { opacity: 0, transform: "scale(.4)" },
      "34%": { opacity: 1, transform: "scale(1)" },
      "84%": { opacity: 1, transform: "scale(1)" },
      "100%": { opacity: 0, transform: "scale(1)" },
    },
    [REDUCED_MOTION]: { animation: "none", opacity: 1 },
  },
  scan: {
    animation: `loginScan 9s ${EASE_OUT} infinite`,
    "@keyframes loginScan": {
      "0%": { transform: "translateY(6px)", opacity: 0 },
      "12%": { opacity: 0.9 },
      "46%": { transform: "translateY(214px)", opacity: 0.9 },
      "58%": { transform: "translateY(214px)", opacity: 0 },
      "100%": { transform: "translateY(214px)", opacity: 0 },
    },
    [REDUCED_MOTION]: { animation: "none", opacity: 0 },
    "& rect": { fill: theme.colors.brand[2], opacity: 0.85 },
  },
}));

// Teeth positions along the arch, in the SVG viewBox coordinates of the design.
const TEETH: [number, number][] = [
  [86, 196],
  [74, 168],
  [68, 138],
  [70, 108],
  [80, 80],
  [98, 56],
  [122, 38],
  [150, 28],
  [180, 26],
  [210, 32],
  [236, 46],
  [256, 68],
  [270, 94],
  [276, 124],
  [276, 156],
  [272, 186],
];

export const TeethAnimation = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.animation} aria-hidden>
      <svg viewBox="-20 -20 384 264" className={classes.arch}>
        <path
          className={classes.archLine}
          d="M 86 200 C 60 150 66 78 118 44 C 160 16 208 22 246 54 C 288 90 288 156 272 190"
        />
        {TEETH.map(([cx, cy], index) => (
          <circle
            key={`${cx}-${cy}`}
            className={classes.tooth}
            cx={cx}
            cy={cy}
            r={9}
            style={{ animationDelay: `${(index * 0.14).toFixed(2)}s` }}
          />
        ))}
        <g className={classes.scan}>
          <rect x={40} y={0} width={264} height={2} rx={1} />
        </g>
      </svg>
    </div>
  );
};
